(function(){
  'use strict';

  var filterTableGlobal = {
    bindings: {
      filter: '<',
      updateFilter: '&',
      clearFilter: '&'
    },
    template: require('./filter-table-global.html'),
    controller: 'FilterTableGlobalCtrl'
  };

  angular
    .module('mandaeApp')
    .component('filterTableGlobal', filterTableGlobal);

}());